import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { getRequest } from 'utils/api';
import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import AdvertiserProfile from './AdvertiserProfile';
import TransitionDialog from 'components/TransitionDialog';
import FullScreenCircularLoader from 'components/FullScreenCircularLoader';

const useStyles = makeStyles(theme => ({
  paperFullScreenDialog: {
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },

    [theme.breakpoints.up('md')]: {
      width: '85%',
      marginLeft: 'auto',
    },

    [theme.breakpoints.up('lg')]: {
      width: '65%',
      marginLeft: 'auto',
    },

    [theme.breakpoints.up('xl')]: {
      width: '45%',
      marginLeft: 'auto',
    },
  },

  paper: {
    backgroundColor: '#f8f9fb',
  },
}));

const AdvertiserProfileDialog = () => {
  const [profile, setProfile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const open = useModalOpen('Advertiser Profile');
  const username = useSelector(state => state.utils.modalData['Advertiser Profile']?.username);
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => dispatch(closeModal('Advertiser Profile'));

  useEffect(() => {
    if (!username) return;
    setIsLoading(true);

    getRequest({
      endpoint: `users/${username}/profile`,
    })
      .then(response => {
        setProfile(response);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [username, dispatch]);

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      direction="left"
      desktopDirection="left"
      dialogStyles={classes.paperFullScreenDialog}
      paperProps={{ className: classes.paper }}
      noCloseIcon
    >
      {isLoading ? (
        <FullScreenCircularLoader />
      ) : (
        <AdvertiserProfile profile={profile} handleClose={handleClose} isDialog />
      )}
    </TransitionDialog>
  );
};

export default AdvertiserProfileDialog;
